export const environment = {
    appVersion: require('../../package.json').version,
    production: true,
    RAZORPAY_KEY: 'rzp_live_IgIBOT2LDLKUAL'
};
